<script>
    import DownloadProgress from "./DownloadProgress.svelte"
    import HumanExpiration from "./HumanExpiration.svelte"
    import HumanFileSize from "./HumanFileSize.svelte"
    import FileControls from "./FileControls.svelte"
    import PasswordField from "./PasswordField.svelte"

    const get_initial_password = () => {
        const url = new URL(location.href)

        return url.searchParams.get('p') || ''
    }

    export let file

    let file_password = get_initial_password()
    let download_progress = null
    let blob = null

    const decrypt = async e => {
        e.preventDefault()
        if (file_password.length < 8) {
            return
        }

        const result = await tx.file_download(file, file_password, e => {
            download_progress = e
        })

        blob = result ?? null
    }
</script>

{#if !file.exists}
    <div class="notification is-danger block">
        Underlying file data is missing, this file has likely expired!
    </div>
{/if}

<div class="box block">
    <div class="level">
        <div class="level-left">
            <HumanExpiration stamp={file.file.expires}/>
        </div>
        <div class="level-right">
            <HumanFileSize bytes={file.file.file_size}/>
        </div>
    </div>
    
    <form on:submit={decrypt}>
        <PasswordField
            bind:value={file_password}
            placeholder="Min 8 characters"
            label="File password"
            id="file_password"/>

        <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
                <button
                    class="button"
                    disabled={file_password.length < 8}>
                    <span>Decrypt</span>
                    <span class="icon">
                        <i class="fas fa-unlock"></i>
                    </span>
                </button>
            </div>
        </div>
    </form>
</div>

<FileControls file={file}/>

<DownloadProgress progress={download_progress}/>

{#if blob}
    <div class="box block has-background-success">
        <div class="level">
            <div class="level-left">
                <span>Your file is ready to download!</span>
            </div>
            <div class="level-right">
                <a
                    href={URL.createObjectURL(blob)}
                    download={file.file.file_name}
                    class="button">
                    <span>Download</span>
                    <span class="icon">
                        <i class="fas fa-download"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
    
{/if}


